import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
// Design tokens. Must load before the app's own stylesheets, which read these
// custom properties with var(). Generated from one source in @mantis-sas/ui.
import '@mantis-sas/ui/tokens.css';
// Section-local custom properties (--doc-*, --table-*, --modal-*, ...). One
// declaration site since MA-48; they used to be copy-pasted into six section
// stylesheets with five conflicting values, settled by bundler order.
import './MantisBusiness/styles/sectionTokens.css';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import reportWebVitals from './reportWebVitals';
import store from "./Redux/create"

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
